

export * from './domain.postrequest'



// WEBPACK FOOTER //
// ./src/app/core/requests/index.ts